/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import LegacyId from './LegacyId/index'
import React from 'react'
import TysiaIconTag from 'DesignSystem/Svgs/TysiaIconTag/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/Phones/Content/Phone/Edit/Content/EditOrAdd/Content/Content/Profiles/Content/Profile/ProfileData/HumanId/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let personPatientHumanReadableIdValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'patient.human_readable_id',
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconTag
  viewPath={`${viewPath}/TysiaIconTag`}
 width={dtSpaceS}
 height={dtSpaceS}
 fill={dtColorsNeutral600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 color={dtColorsNeutral700}
 data="person.patient.human_readable_id"
 text={personPatientHumanReadableIdValueData}
/>
<LegacyId
  viewPath={`${viewPath}/LegacyId`}
/>
</div>
{children}
</React.Fragment>)
}